import { base_url } from "../Utilities/apiUrl";
import packageJson from "../../package.json";
import { post_req } from "../Utilities/apiUtil";

export const writeLog = async (data) => {
  try {
    const payload = {
      log: `${data.message}`,
    };

    const response = await post_req(`${base_url}?method=writelog`, payload);

    if (!response.isValid) {
      console.error("Error occurred while logging:");
    }
  } catch (e) {
    console.error("Error occurred while logging:", e);
  }
};

